import { Text } from '@fhs-legacy/universal-components';

export const StyledText = Text.withConfig({
  variant: 'copyFour',
  textAlign: 'center',
  maxW: '343px',
  alignSelf: 'center',
});
